import React from 'react';
import { useEffect, useState, Fragment } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import ImageGrid from '../../UI/ImageGrid/ImageGrid';
import CardImage from '../../../assets/VCFFormPage/Card.png';

import { Typography, Button, Box, TextField, Grid } from '@mui/material';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const Body = () => {
  const [loading, setLoading] = useState(true);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [companyLink, setCompanyLink] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [success, setSuccess] = useState(false);

  // eslint-disable-next-line
  const [fullName, setFullName] = useState(null);

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      setLoading(true);
      const user = supabase.auth.user();

      let { data, error, status } = await supabase
        .from(PROFILE_TABLE)
        .select(` firstName, lastName, fullName, linkedin, mobile, companyName, companyLink`)
        .eq('id', user.id)
        .single();

      if (data) {
        setFirstName(data.firstName);
        setLastName(data.lastName);
        setFullName(data.fullName);
        setLinkedin(data.linkedin);
        setMobile(data.mobile);
        setCompanyName(data.companyName);
        setCompanyLink(data.companyLink);
      }

      if (error && status !== 406) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    // e.preventDefault();

    try {
      setLoading(true);
      const user = supabase.auth.user();

      const updates = {
        id: user.id,
        firstName: formik.values.firstName,
        lastName: formik.values.lastName,
        fullName: formik.values.firstName + ' ' + formik.values.lastName,
        linkedin: formik.values.linkedin,
        mobile: formik.values.mobile,
        companyName: formik.values.companyName,
        companyLink: formik.values.companyLink,
        updated_at: new Date(),
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
      setSuccess(true);
    }
  };

  const validationSchema = yup.object({
    firstName: yup.string('Enter your first name').required('First name is required'),
    lastName: yup.string('Enter your last name').required('Last name is required'),
    linkedin: yup.string('Enter your LinkedIn').required('LinkedIn is required'),
    mobile: yup.number('Enter your mobile number').required('Mobile number is required'),
    companyName: yup.string('Enter your company name').required('Company name is required'),
    companyLink: yup.string('Enter your company link').required('Company link is required'),
  });

  const formik = useFormik({
    initialValues: {
      firstName: firstName,
      lastName: lastName,
      linkedin: linkedin,
      mobile: mobile,
      companyName: companyName,
      companyLink: companyLink,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateProfile();
    },
  });

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : success ? (
        <Fragment>
          {' '}
          <Typography variant='h4' sx={{ mt: '3rem', mb: '2rem', fontWeight: 'bold' }}>
            Successfully Updated
          </Typography>
          <ImageGrid gridSize={12} src={CardImage} alt={'cards'} />
          <Grid container>
            <Grid xs={12} md={6}>
              <Typography variant='h5' sx={{ mt: '3rem', mb: '2rem', fontWeight: 'bold' }}>
                Have the 100Card already?
              </Typography>
              <Typography variant='body1' sx={{ mt: '1rem' }}>
                Now, anyone can scan your QR code on the card and download your contact details straight away!
              </Typography>
            </Grid>
            <Grid xs={12} md={6}>
              <Typography variant='h5' sx={{ mt: '3rem', mb: '2rem', fontWeight: 'bold' }}>
                Don't have the 100Card?
              </Typography>
              <Typography variant='body1' sx={{ mt: '1rem' }}>
                It'll be coming soon but it's your very own personal smart name card once you get it in a couple of
                weeks!
              </Typography>
            </Grid>
          </Grid>
        </Fragment>
      ) : (
        <Fragment>
          <Typography variant='h4' sx={{ mt: '3rem', mb: '2rem', fontWeight: 'bold' }}>
            Let's get your personal virtual business card up to date!
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              id='firstName'
              name='firstName'
              label='First Name'
              type='firstName'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.firstName}
              onChange={formik.handleChange}
              error={formik.touched.firstName && Boolean(formik.errors.firstName)}
              helperText={formik.touched.firstName && formik.errors.firstName}
            />
            <TextField
              fullWidth
              id='lastName'
              name='lastName'
              label='Last Name'
              type='lastName'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
            />
            <TextField
              fullWidth
              id='linkedin'
              name='linkedin'
              label='LinkedIn'
              type='linkedin'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.linkedin}
              onChange={formik.handleChange}
              error={formik.touched.linkedin && Boolean(formik.errors.linkedin)}
              helperText={formik.touched.linkedin && formik.errors.linkedin}
            />
            <TextField
              fullWidth
              id='mobile'
              name='mobile'
              label='Mobile Number'
              type='mobile'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.mobile}
              onChange={formik.handleChange}
              error={formik.touched.mobile && Boolean(formik.errors.mobile)}
              helperText={formik.touched.mobile && formik.errors.mobile}
            />
            <TextField
              fullWidth
              id='companyName'
              name='companyName'
              label='Company Name'
              type='companyName'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.companyName}
              onChange={formik.handleChange}
              error={formik.touched.companyName && Boolean(formik.errors.companyName)}
              helperText={formik.touched.companyName && formik.errors.companyName}
            />
            <TextField
              fullWidth
              id='companyLink'
              name='companyLink'
              label='Company Link'
              type='companyLink'
              sx={{
                mb: '1.5rem',
              }}
              value={formik.values.companyLink}
              onChange={formik.handleChange}
              error={formik.touched.companyLink && Boolean(formik.errors.companyLink)}
              helperText={formik.touched.companyName && formik.errors.companyName}
            />

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button color='primary' variant='contained' fullWidth type='submit'>
                Update
              </Button>
            </Box>
          </form>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Body;
